import React, { useState, useEffect } from 'react';
import CallToAction from './CallToAction';
import InquiryForm from './InquiryForm';

export default function HeroSection({ desktopFormRef }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // Choose the right image based on isMobile
  const bgImage = isMobile
    ? '/assets/top-banner-mobile.png'
    : '/assets/top-banner.png';
  return (
    <section
      className="relative h-[350px] md:h-auto w-full bg-cover bg-center pt-14 md:py-10 border-none md:border-t-[10px] md:border-b-[10px] md:border-blue-900 z-[5]"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute z-10 bg-[#ffffff67] md:bg-transparent top-0 left-0 h-full w-full"></div>
      <div className="mx-auto justify-between items-center px-4 md:px-10">
        <div className="absolute inset-0 bg-white bg-opacity-30"></div>

        <div className="relative z-10 grid md:grid-cols-2 ">
          <div className="space-y-5">
            {/* <Header /> */}
            <CallToAction />
          </div>

          {/* Right Section - Inquiry Form */}
          <div className="justify-end hidden md:flex">
            <InquiryForm ref={desktopFormRef} />
          </div>
        </div>
      </div>
      <div className="bg-[#282365] text-white text-3xl font-normal px-4 py-2 w-max rounded-md mt-3 hidden md:block z-[999] absolute top-[50%] left-[-10px] shadow-xl">
        <span className="pl-3 inline-block p-3">
          <span>
            <span>Join Us for the </span>
            <span className="text-3xl font-bold inline-block"> 2025-26 </span>
            <span> Academic</span>
          </span>
          <br />
          <span className="text-3xl inline-block">
            Year - Applications Open
          </span>
        </span>
      </div>

      <div className="absolute bottom-0 left-[40%] hidden md:block">
        <img
          className="h-[480px] w-[auto] ml-[-40px]"
          src="/assets/banner-girl.png"
          alt=""
        />
      </div>
    </section>
  );
}
